import { call, put } from "redux-saga/effects";
import {
  fetchGiftCardBalance,
  fetchWalletBalance,
} from "../../../Api/getBalances";

import {
  fetchBalanceByWalletSuccess,
  fetchBalanceByWalletFailure,
  fetchBalanceByGiftCardSuccess,
  fetchBalanceByGiftCardFailure,
} from "../../giftBalance/giftBalanceActions";
import {
  startLoadingIndicator,
  stopLoadingIndicator,
} from "../../loadingIndicator/loadingIndicatorActions";

export function* handleFetchBalanceByWallet({ payload: { mobileNumber } }) {
  try {
    yield put(startLoadingIndicator());
    const response = yield call(fetchWalletBalance, { mobileNumber });

    const { walletBalance } = response?.data?.data?.wallets?.[0] || {};
    yield put(fetchBalanceByWalletSuccess({ balance: walletBalance || 0 }));

    yield put(stopLoadingIndicator());
  } catch (error) {
    console.log(`handleFetchBalanceByWallet error = ${error}`);
    yield put(fetchBalanceByWalletFailure({ error }));
    yield put(stopLoadingIndicator());
  }
}

const parseCardData = (response) => ({
  amount: response?.data?.amount,
  cardExpiry: response?.data?.cardExpiry,
});

export function* handleFetchBalanceByGiftCard({ payload: { cardNumber } }) {
  try {
    yield put(startLoadingIndicator());
    const response = yield call(fetchGiftCardBalance, { cardNumber });
    const { data } = response;
    if (data?.code === "SUCCESS") {
      const { amount, cardExpiry } = parseCardData(response);
      if (amount && cardExpiry) {
        yield put(
          fetchBalanceByGiftCardSuccess({ balance: { amount, cardExpiry } }),
        );
      } else {
        yield put(
          fetchBalanceByGiftCardSuccess({
            balance: { amount: 0, cardExpiry: null },
          }),
        );
      }
    } else if (data?.code === "INVALID_CARDNUMBER") {
      yield put(
        fetchBalanceByGiftCardFailure({
          message: "invalidCardNumber",
        }),
      );
    } else {
      yield put(
        fetchBalanceByGiftCardFailure({
          message: "somethingWentWrong",
        }),
      );
    }
  } catch (error) {
    console.log(`handleFetchBalanceByGiftCard error = ${error}`);
    yield put(
      fetchBalanceByGiftCardFailure({
        message: "somethingWentWrong",
      }),
    );
  }
  yield put(stopLoadingIndicator());
}
